
import cms from '~/mixins/common/cms'
import floatingIcons from '~/mixins/common/floating-icons'
export default {
    name: 'SupportButton',
    mixins: [cms, floatingIcons],
    created() {
        this.$nuxt.$on('@toggleSupport', (val) => {
            this.messageFab = val
        })
    },
    destroyed() {
        this.$nuxt.$off('@toggleSupport')
    },
}
